import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export default function Card(theme: Theme) {
  const isLight = theme.palette.mode === 'light';
  const cardBorder = isLight ? theme.palette.grey[300] : alpha(theme.palette.common.white, 0.16);
  const cardBorderHover = isLight
    ? theme.palette.grey[400]
    : alpha(theme.palette.common.white, 0.24);
  const cardShadow = isLight
    ? `0 1px 2px ${alpha(theme.palette.grey[900], 0.04)}`
    : `0 1px 3px ${alpha(theme.palette.common.black, 0.35)}`;
  const cardShadowHover = isLight
    ? `0 4px 14px ${alpha(theme.palette.grey[900], 0.07)}`
    : `0 6px 20px ${alpha(theme.palette.common.black, 0.45)}`;

  return {
    MuiCard: {
      styleOverrides: {
        root: {
          border: `0.5px solid ${cardBorder}`,
          boxShadow: cardShadow,
          borderRadius: Number(theme.shape.borderRadius),
          backgroundColor: theme.palette.background.paper,
          position: 'relative',
          zIndex: 0, // Fix Safari overflow: hidden with border radius
          transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
          '&:has(.MuiCardActionArea-root):hover': {
            borderColor: cardBorderHover,
            boxShadow: cardShadowHover
          }
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2' }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2.5),
          '&:last-child': {
            paddingBottom: theme.spacing(2.5)
          }
        }
      }
    }
  };
}
